import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createDraftCpd, getCpdChatId } from 'shared/actions/cpd';
import { CPDHomeownerTrap, CPDSuccessScreen, CPDPrelanding } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/CPDTrap/types';
import { useCpdTracking } from 'shared/containers/valuationTraps/utils/tracking/cpd';
import { selectOffer } from 'shared/selectors';
import { selectCpdDraftId, selectCpdDraftStatus } from 'shared/selectors/cpd/cpd';
import { ECpdDraftStatus } from 'shared/types/cpd/cpd';

export const CPDTrapContainer: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const dispatch = useDispatch();

  const { trackCPDGoToChatClick, trackCPDTrapVisible, trackCPDTrapClick, trackCPDCreateDraftClick } = useCpdTracking();

  const cpdDraftStatus = useSelector(selectCpdDraftStatus);
  const cpdDraftId = useSelector(selectCpdDraftId);
  const offer = useSelector(selectOffer);

  const { config } = useApplicationContext();
  const prelandingContent = config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  const onTrapClick = React.useCallback(() => {
    setIsModalOpen(true);
    trackCPDTrapClick();
  }, []);

  const onCloseTrapModal = React.useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const onCreateDraftCpd = React.useCallback(async () => {
    trackCPDCreateDraftClick();
    await dispatch(createDraftCpd());
  }, [dispatch]);

  const onGoCianChat = React.useCallback(
    async (draftId?: number) => {
      trackCPDGoToChatClick(draftId);

      const chatId = await dispatch(getCpdChatId());

      const url = chatId ? `https://www.cian.ru/dialogs/?chatId=${chatId}` : 'https://www.cian.ru/dialogs/?';
      window.open(url);
    },
    [dispatch],
  );

  if (!prelandingContent?.homeowner) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackCPDTrapVisible} callbackDelay={1000}>
      <>
        <CPDHomeownerTrap onClick={onTrapClick} />
        <ModalWindow
          header={<div />}
          open={isModalOpen}
          onClose={onCloseTrapModal}
          content={
            cpdDraftStatus === ECpdDraftStatus.success ? (
              <CPDSuccessScreen cpdDraftId={cpdDraftId} onGoCianChat={onGoCianChat} />
            ) : (
              <CPDPrelanding
                cpdDraftStatus={cpdDraftStatus}
                onCreateDraftCpd={onCreateDraftCpd}
                prelandingContent={prelandingContent.homeowner}
                category={offer.category}
              />
            )
          }
          size="XS"
          width={540}
        />
      </>
    </ActionAfterViewObserver>
  );
};
